/*
* 支付页
*/
import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import QRCode from 'qrcode.react';
import axios from 'axios';
import UA from '../../utils/ua';
import AXIOS from '../../api/axios';
import { apiDefine } from '../../api/web';
import { COURSE_URL } from "../../constants";
import { parseQuery, myStorage } from '../../utils/tools';
import Toast from '../../utils/toast';
import clientApi from '../../api/client';
import PhonicsPay from '../../template/UniversePay/main';
import Load from '../../template/Load/Load';
import WebViewHeader from '../../template/WebViewHeader/WebViewHeader';

const queryObj = parseQuery(window.location.search.slice(1));
const returnUrl = `https://client.aircourses.com/h5/success`;

class PhonicsPayPage extends Component {
    constructor(props) {
        super(props);
        this.isMobile = UA.mobileClient;
        this.interval = [];
        this.timeout = [];
        this.state = {
            completeRander: false,
            refuseClick: false, // 禁止点击
            coursesInfo: {},
            courseId: queryObj.courseid,
            inviteAwardList: [], // 赠品列表
            discountCoupon: {},
            notUseDiscount: '0', // 是否选择优惠券
            isHasDiscount: false, // 是否有可用优惠券
            isAllowAgreement: true, // 是否允许协议
        }
    }

    componentWillUnmount(){
        this.interval.map(ele => (clearInterval(ele)));
        this.timeout.map(ele => (clearTimeout(ele)));
    }

    componentWillMount() {
        if(localStorage.getItem('is_allow_agreement')) {
            this.setState({
                isAllowAgreement: localStorage.getItem('is_allow_agreement')
            })
            localStorage.removeItem('is_allow_agreement')
        }
        apiDefine({ apiName: 'alertViewBack', fn: this.alertViewBack }); // 定义弹框回调方法
       
        this.getAddress(queryObj.stuid) // 获取地址
        this.GetGoodInfo(queryObj.goodsid) // 获取套餐信息
        this.GetDiscountList(queryObj.goodsid) // 获取优惠券列表

    }
    // 获取地址
    getAddress = userId => {
        const storage = myStorage;
        storage.removeItem('user_address');
        // 获取地址信息
        return AXIOS.getAddress({ data: { userId: userId } }, (res, err) => {
            if(err) console.log(err);
            else {
                if (res.length) {
                    this.setState({
                        userAddress: res[0],
                        addressId: res[0].id
                    });
                    storage.setItem('user_address', JSON.stringify(res[0]));
                    return res[0].id;
                } else {
                    storage.setItem('user_address', JSON.stringify({
                        consignee: "",
                        consigneePhone: "",
                        province: "",
                        city: "",
                        area: "",
                        detail: ""
                    }));
                }
                return true;
            }
        });
    }
    // 获取套餐信息
    GetGoodInfo = (goodsId) => {
        AXIOS.getGoodInfo({query: goodsId}, (res, err) => {
            if(err) console.log(err)
            else {
                this.setState({
                    coursesInfo: res || {},
                    completeRander: true,
                })
            }
        });
        AXIOS.getGoodsInviteAward({data: {
            goodsId: goodsId
        }},(res, err) => {
            if(err) console.log(err);
            else if (res.length){
                this.setState({inviteAwardList: res});
            }
        })
    }

    // 获取优惠券列表
    GetDiscountList = (goodsId) => {
        const { yange } = queryObj;
        if(Number(yange) === 1) { // 审核中
            return;
        }
        if(localStorage.getItem('no_use_discount') === '1') { // 已选不使用优惠券
            this.setState({
                notUseDiscount: '1',
                isHasDiscount: true // 有优惠券可用
            })
            localStorage.removeItem('no_use_discount')
            return
        }
        let discountCoupon = localStorage.getItem('user_discount');
        if (discountCoupon) { // 已选择过优惠券则直接使用
            this.setState({
                discountCoupon: JSON.parse(discountCoupon),
                isHasDiscount: true // 有优惠券可用
            })
            localStorage.removeItem('user_discount') // 清除，下次进入则重新接口获取
            return
        }
        AXIOS.getDiscountList({data: { goodsId }}, (res, err) => {
            if(err) console.log(err)
            else {
                if (res.length > 0) { // 有可以使用的优惠券则选择第一张
                    this.setState({
                        discountCoupon: res[0],
                        isHasDiscount: true // 有优惠券可用
                    })
                } else {
                    this.setState({
                        discountCoupon: {},
                        isHasDiscount: false // 无优惠券可用
                    })
                }
            }
        })
    }

    checkOrder = () => {
        const { orderNo } = this.state;
        AXIOS.getOrderStatus({ query: orderNo + '' }, (res, err) => {
            if(err) return;
            else {
                if (res.status === 1) {
                    clientApi.closeH5Page({ reason: 'closeSafe' })
                } else {
                    Toast.info({ text: '支付未完成' })
                }
            }
        })
    }

    // 第三方支付下单
    handlePay = (orderNo, payType) => {
        Toast.info({ text: '支付进行中，请勿退出当前页面' });
        if (payType === 0) { // 微信
            let data = { orderNo: orderNo, payType: 'MWEB'};
            AXIOS.payWeixin({ data }, (res, err) => {
                if (err) alert(err.errorMessage);
                else {
                    const { mwebUrl } = res;
                    if (UA.iphoneClient) {
                        window.location.replace(`${mwebUrl}`);
                    }
                    else if (UA.androidClient) {
                        window.location.replace(`${mwebUrl}&redirect_url=${encodeURIComponent(returnUrl+"?stuid="+queryObj.stuid+"&totalamount="+this.state.totalAmount+"&success=1&type=wait&orderno="+orderNo)}&courseid=${queryObj.courseid}`);
                    }
                }
            });
        } else {
            const data = { // 支付宝
                returnUrl: `${returnUrl}?stuid=${queryObj.stuid}&orderno=${orderNo}&totalamount=${this.state.totalamount}&success=1&type=wait&courseid=${queryObj.courseid}`,
                orderNo: orderNo,
                payType: 'QUICK_WAP_PAY'
            };
            axios.post(`https://api.aircourses.com/ac-order/alipay`, data)
                .then(function (res) {
                    document.getElementById('root').innerHTML = res.data;
                    setTimeout(()=>{ document.forms[0].submit() },500)
                })
                .catch(function (err) {
                    alert('error'+JSON.stringify(err));
                });
        }
//        this.GetDiscountList(this.state.coursesInfo.id)
    }

    // 获取订单号
    handleClick = (goodsNo, payType, inviteAwardPackId, isHaveEntity) => {
        const { addressId, refuseClick, isAllowAgreement, inviteAwardList } = this.state;
        const { yange } = queryObj;
        this.setState({
            inviteAwardPackId,
            isHaveEntity
        });
        if(!isAllowAgreement) {
            clientApi.alertView({
                content: '请同意用户支付协议',
                confirm: '确定',
                id: 'H5_1006'
            });
            return;
        }
        if (refuseClick) return;
        this.setState({ refuseClick: true });
        // applereviewing为1审核模式 || 没有赠品 || 有赠品有地址 不提示
        if(!inviteAwardList.length || (inviteAwardList.length && addressId) || Number(yange) === 1){
            if (this.isMobile){ // 安卓或苹果 非内购
                let data = {
                    stuCouponDetailIds: (!!this.state.discountCoupon && this.state.discountCoupon.id) ? [this.state.discountCoupon.id] : [],
                    userId: queryObj.stuid,
                    payType: payType === 0 ? 'MWEB' : 'QUICK_WAP_PAY',
                    channelId: queryObj.channel, // app渠道id
                    version: 2, // 接口版本
                    goodsNo,
                    addressId: isHaveEntity ? addressId : null, // 有实物赠品才传addressId
                    inviteAwardPackId
                }
                if(window.location.origin !== "https://client.aircourses.com"){
                    return this.fakePay(data);
                }
                AXIOS.getWxOrder({ data }, (res, err) => {
                    if(err) alert('获取订单失败：' + err.errorMessage)
                    else {
                        this.setState({ orderNo: res.orderNo/*, notUseDiscount: '0', isHasDiscount: false*/ });
                        if(res.status !== 1) { // 未支付成功
                            this.handlePay(res.orderNo, payType); // 获取订单号成功 第三方支付
                        } else {
                            this.GetDiscountList(this.state.coursesInfo.id)
                            alert('支付成功')
                        }
                    }
                    this.setState({ refuseClick: false });
                })
            } else { 
                // 桌面或ipad扫码支付
                this.setState({ showErweima: true, refuseClick: false });
            }
        } else {
            this.setState({ refuseClick: false });
            clientApi.alertView({
                title: '提示',
                content: '我们会为您寄送一份实验器材包，请先填写收货地址哦～',
                confirm: '去填写',
                cancel: '取消',
                id: 'H5_1001'
            })
        }
    }

    // 选择地址(实验课)
    handleAddress = () => {
        const { history } = this.props;
        const { addressId, isAllowAgreement, notUseDiscount, discountCoupon } = this.state;
        history.push({
            pathname: `${COURSE_URL}/address`,
            search: window.location.search,
            state: {
                addressId: addressId,
                isAllowAgreement: isAllowAgreement,
                notUseDiscount: notUseDiscount, // 是否选择使用优惠券
                discountCoupon: discountCoupon,
                source: 'universemk' //告诉目标页面上一页地址
            }
        });
    }

    // 选择优惠券
    handleDiscount = () => {
        const { history } = this.props;
        history.push({
            pathname: `${COURSE_URL}/discountcoupon`,
            search: window.location.search,
            state: {
                goodsId: queryObj.goodsid || this.state.coursesInfo.id,
                couponId: (this.state.discountCoupon && this.state.discountCoupon.id) || -1,
                notUseDiscount: this.state.notUseDiscount, // 是否选择使用优惠券
                discountCoupon: this.state.discountCoupon,
                isAllowAgreement: this.state.isAllowAgreement
            }
        });
    }

    // 是否同意支付协议
    agreementSelect = () => {
        this.setState({
            isAllowAgreement: !this.state.isAllowAgreement
        })
    }

    // 跳转至支付协议
    clickToAgreement = () => {
        const { history } = this.props;
        history.push({
            pathname: `${COURSE_URL}/paymentAgreement`,
            state: {
                isAllowAgreement: this.state.isAllowAgreement,
                notUseDiscount: this.state.notUseDiscount, // 是否选择使用优惠券
                discountCoupon: this.state.discountCoupon,
            }
        });
    }

    alertViewBack = (res) => {
        const data = JSON.parse(res);
        if(data.select === 'confirm'){
            if(data.id === 'H5_1001'){
                this.handleAddress();
            } else if(data.id === 'H5_1003'){
                this.checkOrder();
            }
        }
    }
    // 虚拟支付
    fakePay = (data) => {
        AXIOS.payTest({data},(res, err) => {
            if(err) console.log(err);
            else{
                Toast.info({ text: '虚拟支付完成' });
            }
            this.setState({ refuseClick: false });
        })
    }

    render(){
        const {
            userAddress,
            coursesInfo,
            courseId,
            showErweima,
            addressId,
            completeRander,
            isHasDiscount,
            discountCoupon,
            notUseDiscount,
            isAllowAgreement,
            inviteAwardList,
            inviteAwardPackId,
            isHaveEntity
        } = this.state;

        return(
            <DocumentTitle title={'确认订单'}>
                <React.Fragment>
                    { !completeRander &&
                        <Load />
                    }
                    { !this.isMobile &&
                        <WebViewHeader showBack={ false } showClose={ false } title="确认订单" />
                    }
                    <PhonicsPay
                        yange={ queryObj.yange }
                        handleAddress={ this.handleAddress }
                        handleDiscount={ this.handleDiscount }
                        userAddress={ userAddress }
                        coursesInfo={ coursesInfo }
                        courseId={ courseId }
                        handleClick={ this.handleClick.bind(this) }
                        agreementSelect={ this.agreementSelect }
                        appleIAP={ queryObj.apple_iap }
                        notUseDiscount={notUseDiscount}
                        isHasDiscount={isHasDiscount}
                        isAllowAgreement={isAllowAgreement}
                        clickToAgreement={this.clickToAgreement}
                        discountCoupon={discountCoupon}
                        inviteAwardList={inviteAwardList}
                    />
                    { !!showErweima &&
                        <div className="erweima_wrap nasa" onClick={() => { this.setState({ showErweima: false }) }}>
                            <div className="erweima">
                                { isHaveEntity ?
                                    <QRCode
                                        size={ 148 }
                                        value={`${window.location.origin}/h5/paylink?channel=${queryObj.channel}&userid=${queryObj.stuid}&goodsno=${coursesInfo.goodsNo}&addressid=${addressId}&couponid=${discountCoupon.id || '-1'}&inviteawardpackid=${inviteAwardPackId}`}
                                        fgColor='#333'
                                    />
                                    :
                                    <QRCode
                                        size={ 148 }
                                        value={`${window.location.origin}/h5/paylink?channel=${queryObj.channel}&userid=${queryObj.stuid}&goodsno=${coursesInfo.goodsNo}&couponid=${discountCoupon.id || '-1'}&inviteawardpackid=${inviteAwardPackId}`}
                                        fgColor='#333'
                                    />
                                }
                                <span>请用手机支付宝或微信扫码付款</span>
                            </div>
                            {/* <div className="closeBtn">已支付</div> */}
                        </div>
                    }
                </React.Fragment>
            </DocumentTitle>
        )
    }
}

export default PhonicsPayPage;



// WEBPACK FOOTER //
// ./src/components/UniversePayPage/UniversePayPage.jsx